const HeaderSlash = () => <div className = "slash" />
export default HeaderSlash;